import axios from "../axios";

const buildCorporatePath = (corporateId) => {
  if (!corporateId) {
    return "";
  }

  return encodeURIComponent(String(corporateId).trim());
};

const existsByCorporateId = (corporateId) => {
  const path = buildCorporatePath(corporateId);
  if (!path) {
    return Promise.resolve({ data: { exists: false } });
  }

  return axios.get(`/org-admins/corporates/${path}/exists`);
};

const resolveByCorporateId = (corporateId) => {
  const path = buildCorporatePath(corporateId);
  if (!path) {
    return Promise.resolve({ data: null });
  }

  return axios.get(`/org-admins/corporates/${path}`);
};

export default {
  existsByCorporateId,
  resolveByCorporateId,
};
